import { createSelector } from 'reselect';

const selectProductionPlants = (state: any) => state.productionPlants;


export const selectProductionPlantsCurrentItem = createSelector([selectProductionPlants], (productionPlants) => productionPlants.current);

export const selectProductionPlantsListItems = createSelector([selectProductionPlants], (productionPlants) => productionPlants.list);

export const selectProductionPlantsItemById = (itemId: any) =>
    createSelector(selectProductionPlantsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductionPlantsQueryItems = createSelector([selectProductionPlants], (productionPlants) => productionPlants.query);

export const selectProductionPlantsCreatedItem = createSelector([selectProductionPlants], (productionPlants) => productionPlants.create);

export const selectProductionPlantsUpdatedItem = createSelector([selectProductionPlants], (productionPlants) => productionPlants.update);

export const selectProductionPlantsReadItem = createSelector([selectProductionPlants], (productionPlants) => productionPlants.read);

export const selectProductionPlantsDeletedItem = createSelector([selectProductionPlants], (productionPlants) => productionPlants.delete);

export const selectProductionPlantsSearchedItems = createSelector([selectProductionPlants], (productionPlants) => productionPlants.search);

export const selectProductionPlantsItemsCount = createSelector([selectProductionPlants], (productionPlants) => productionPlants.count);

export const selectProductionPlantsItemsFilter = createSelector([selectProductionPlants], (productionPlants) => productionPlants.filter);